/**
 * NotFoundPage
 *
 * This is the page we show when the user visits a url that doesn't have a route
 *
 * NOTE: while this component should technically be a stateless functional
 * component (SFC), hot reloading does not currently support SFCs. If hot
 * reloading is not a necessity for you then you can refactor it and remove
 * the linting exception.
 */

import React from 'react';

export default class NotFound extends React.PureComponent {
  // eslint-disable-line react/prefer-stateless-function

  componentWillMount() {
    let redirectTo = 'https://www.lynks.com';
    const oldPagesRoutes = [
      [
        /\/(en|ar)\/eg\/lynks_vs_edfa3ly$/gm,
        'https://www.lynks.com/lynks-vs-edfa3ly',
      ],
      [/\/(en|ar)\/..\/order$/m, 'https://www.lynks.com/cart'],
    ];
    oldPagesRoutes.map((route) => {
      if (route[0].test(window.location.pathname)) {
        redirectTo = route[1];
      }
    });
    window.location = redirectTo;
  }

  render() {
    return null;
    // <h1>
    //   <FormattedMessage {...messages.header} />
    // </h1>
  }
}



// WEBPACK FOOTER //
// ./app/containers/NotFoundPage/index.js